<template>

  <svg :class="{pulse:pulse&&enabled,dark:dark,small:small}" xmlns="http://www.w3.org/2000/svg" :viewBox="enabled?'0 0 448 512':'0 0 384 512'">
	<path v-if="enabled" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"/>
	<path v-if="!enabled&&!hideCross" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/>
</svg>

</template>

<script>
export default {
  name: 'TickCross',
  props: {
	enabled: {
	  type: Boolean,
	  default: false
	},
	pulse: {
	  type: Boolean,
	  default: true
	},
	dark: {
	  type: Boolean,
	  default: false
	},
	small: {
	  type: Boolean,
	  default: false
	},
	hideCross: {
	  type: Boolean,
	  default: false
	}
  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
@keyframes pulseAnimation {
    0% { fill: #fff; } 
    50% { fill: @formDefaultColour; }
    100% { fill: #fff; }
}
@keyframes pulseAnimationDark {
    0% { fill: @darkContrast; } 
    50% { fill: @formDefaultColour; }
    100% { fill: @darkContrast; }
}
svg {
	width: 16px;
	height: auto;
	fill: #fff;
	&.dark {
		fill: @darkContrast;
	}
	&.small {
		width: 12px;
	}
	&.pulse {

		animation: pulseAnimation 2s infinite;

		&.dark {

			animation: pulseAnimationDark 2s infinite;

		}

	}
}
@media screen and (min-width: 960px) {

}
</style>